import React from "react";
import Showcase from '../components/Showcase'
import BackgroundVideo from '../components/BackgroundVideo';
import FlexCenterCenter from '../components/FlexCenterCenter';
import ShowcaseContent from '../components/ShowcaseContent';
import PackagesStrip from '../components/PackagesStrip';
import MissionStatementStrip from '../components/MissionStatementStrip';
import WhyChoosePD from '../components/WhyChoosePD';
// import ImageStrip from '../components/ImageStrip';
// import stripImage from '../img/gtr.jpg';

function Home() {
  return (
    <>
      <Showcase>
        <FlexCenterCenter>
          <BackgroundVideo>
            <ShowcaseContent/>
          </BackgroundVideo>
        </FlexCenterCenter>
      </Showcase>
      <PackagesStrip/>
      <MissionStatementStrip/>
      {/* <ImageStrip image={stripImage}/> */}
      <WhyChoosePD/>
    </>
  );
}

export default Home;
